export default __webpack_public_path__ + "static/media/vállakozásépítés.8bb9726d.png";